import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";

export default function DashboardRouter() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return user.role === "admin" ? <AdminDashboard /> : <Dashboard />;
}
